export default "__VITE_ASSET__17TxfsFjzFP3b9D6r0qR9w__";